const PRODUCT_DIALOG_MODE = {
    CREATE: 1,
    READ: 2,
    UPDATE: 3,
};

export default PRODUCT_DIALOG_MODE;
